import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { PDFDocumentProxy } from 'pdfjs-dist';
import { NgxSpinnerService } from 'ngx-spinner';
import { FunctionsService } from 'src/app/services/functions.service';

@Component({
    selector: 'app-pdf-view',
    templateUrl: './pdf-view.component.html',
    styleUrls: ['./pdf-view.component.css']
})
export class PdfViewComponent implements OnInit {
    @Input() set fileToView(value: any) {
        this.file.name = value.name;
        this.file.filePath = value.path;
    }

    file: any = {
        name: "",
        filePath: ""
    };

    constructor(
        private spinner: NgxSpinnerService,
        public activeModal: NgbActiveModal,
        public language: TranslateService,
        public functionsService: FunctionsService) { }

    ngOnInit() {
        this.spinner.show();
    } 

    callBackFn(pdf: PDFDocumentProxy) {
        this.spinner.hide()
    }
}
